import React, { useEffect, useState } from "react";
import {
  Card,
  CardActionArea,
  Stack,
  Grid,
  Paper,
  CardContent,
  Typography,
} from "@mui/material";
import { useUser } from "../../../globals/UserContext";
import { useClass } from "../../../globals/ClassContext";
import axios from "axios";
import { useSetAssignment } from "../../../globals/AssignmentContext";
import { fetchAssignmentAction } from "../../../actions/fetchAssignment";
import { useSetAssignmentReview } from "../../../globals/AssignmentReviewContext";
import AssignmentModal from "./AssignmentModal.js";
import { useSetQuestion } from "../../../globals/QuestionContext";

const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

function AssignmentCard(props) {
  const assignmentID = props.assignment._id;

  const singleAssignment = props.assignment;

  const user = useUser();

  const setAssignment = useSetAssignment();
  const setAssignmentReview = useSetAssignmentReview();
  const setQuestion = useSetQuestion();

  const OpenAssignment = (event) => {
    fetchAssignmentAction(assignmentID, setAssignment, setQuestion);
    props.setPage("home");
  };

  //function called when the student wants to review a submission.
  const reviewAssignment = (event) => {
    setAssignmentReview({
      user: user,
      assignmentID: assignmentID,
    });

    props.setPage("assignmentReview");
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const displayModal = (event) => {
    setIsModalOpen(true);
  };

  //We return the newly created assingment to the
  return (
    <>
      <Card
        component={Paper}
        sx={{
          minheight: 55,
          backgroundColor: "rgb(213,224,245)",
          "&:hover": {
            backgroundColor: "rgb(183,193,211)",
          },
        }}
        aligncontent="center"
        justifycontent="center"
        //change to the editor page with the assignment
      >
        <CardActionArea
          onClick={
            singleAssignment.opened === true
              ? singleAssignment.closed === true
                ? reviewAssignment
                : OpenAssignment
              : displayModal
          }
        >
          <CardContent>
            <Grid
              container
              //spacing={1}
              //justifyContent = "center"
              //alignItems = "center"
            >
              <Grid item xs>
                <Typography align="left">{singleAssignment.name}</Typography>
              </Grid>
              <Grid item xs>
                <Typography align="left">
                  {singleAssignment.opened === false
                    ? "Opens: " +
                      new Date(singleAssignment.open_date).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                        }
                      )
                    : ""}
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography align="right">
                  {singleAssignment.completed === false
                    ? "Due: " +
                      new Date(singleAssignment.due_date).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                        }
                      )
                    : "Assignment Completed"}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </CardActionArea>
      </Card>
      {isModalOpen && (
        <AssignmentModal
          closeModal={() => setIsModalOpen(false)}
          modalTitle="This assignment is not open yet."
          modalMessage={
            "Please wait until " +
            new Date(singleAssignment.open_date).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "numeric",
            })
          }
        />
      )}
    </>
  );
}

export default function Assignments(props) {
  const user = useUser();
  const assignmentAttempts = user.assignment_attempts;
  const classroom = useClass();
  const assignmentIDs = classroom.assignments;
  const style = props.filter;
  const [assignmentObjects, setAssignmentObjects] = useState([]);

  useEffect(() => {
    const completedAssignments = [];
    assignmentAttempts.forEach((attempt) => {
      if (attempt.isCompleted === true) {
        completedAssignments.push(attempt.assignment);
      }
    });

    if (assignmentIDs && assignmentIDs.length > 0) {
      const fetchData = async () => {
        const requests = assignmentIDs.map((id) =>
          axios.get(`${REACT_APP_DEBUGGER_SERVER_URL}/assignment/${id}`)
        );
        const responses = await axios.all(requests);
        const data = responses.map((response) => response.data);
        const loadedAssignments = data.filter((assignment) => {
          const assignmentDueDate = new Date(assignment.due_date);
          const assignmentOpenDate = assignment.open_date
            ? new Date(assignment.open_date)
            : 0;
          const today = new Date();
          const nextWeek = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);
          if (today >= assignmentOpenDate) {
            assignment.opened = true;
          } else {
            assignment.opened = false;
          }
          if (completedAssignments.includes(assignment._id)) {
            assignment.completed = true;
            assignment.closed = true;
          } else {
            assignment.completed = false;
            if (today > assignmentDueDate) {
              assignment.closed = true;
            } else {
              assignment.closed = false;
            }
          }

          if (style === "upcomming") {
            return (
              //assignment.opened &&
              today <= assignmentDueDate &&
              assignmentDueDate <= nextWeek &&
              !assignment.completed
            );
          } else if (style === "past") {
            return (
              (assignment.opened && assignmentDueDate < today) ||
              assignment.completed
            );
          } else if (style === "future") {
            return today <= assignmentDueDate && !assignment.completed;
          }
          return true;
        });
        setAssignmentObjects(loadedAssignments);
      };
      fetchData();
    } else {
      setAssignmentObjects([]);
    }
  }, [assignmentIDs, style, classroom, assignmentAttempts]);

  //sort the assignments by date
  assignmentObjects.sort((a, b) => new Date(a.due_date) - new Date(b.due_date));
  if (assignmentObjects.length === 0) {
    let message = "You have no assignments";
    if (style === "upcomming") {
      message = "You have no upcoming assignments.";
    } else if (style === "past") {
      message = "You have no past assignments.";
    } else if (style === "future") {
      message = "You have no future assignments.";
    }
    return <Typography align="center">{message}</Typography>;
  }

  return (
    <Stack spacing={2}>
      {assignmentObjects.map((assignment) => (
        <AssignmentCard
          key={assignment._id}
          assignment={assignment}
          setPage={props.setPage}
        />
      ))}
    </Stack>
  );
}
